import { restClient } from '../../client';


export const getOnboardingInviteToken = (userId: string) => restClient.request<{
  data: {
    inviteToken?: string;
  };
}>('/api/v1/onboarding/invite_token', {
  params: {
    user_id: userId
  },
});
